import React from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

let styles;

const FooterColumn = props => (
  <div className={css(styles.container)}>
    <div className={css(styles.header)}>
      {props.title}
    </div>
    {props.children}
  </div>
);

export default FooterColumn;

FooterColumn.defaultProps = {
  children: null,
};

FooterColumn.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node).isRequired,
    PropTypes.object,
  ]),
};

styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '25%',

    [Theme.mobile_query]: {
      width: '50%',
      padding: '0 20px',
      flexShrink: 0,
      marginBottom: 30,
    },
  },
  header: {
    display: 'flex',
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    color: Theme.white,
    fontSize: 15,
    letterSpacing: 1,
    marginBottom: 25,
  },
});



// WEBPACK FOOTER //
// ./src/components/FooterColumn/index.js